<template>
    <li :class="['advert-item']" data-item-type="advert" :data-page="item.page">
        <div style="line-height: 0">
            <a :href="item.link" target="_blank" class="advert-link">
                <advert-image
                    :mobile="mobile"
                    :item="item"
                    :scale-of-screen="scaleOfScreen"
                ></advert-image>
            </a>
        </div>
    </li>
</template>

<style scoped lang="scss">
.advert-item {
    width: auto !important;
    padding: 0px !important;
    overflow: hidden;
}
.advert-link {
    display: inline-block;
}
</style>

<script setup lang="ts">
import { type PropType } from "vue";
import { type IAdvertItem } from "../../list-item";
import advertImage from "../common/advert-image.vue";

defineProps({
    item: {
        type: Object as PropType<IAdvertItem>,
        required: true,
    },
    mobile: Boolean,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
});
</script>

<script lang="ts">
export default {
    model: {
        prop: "item",
    },
};
</script>
